import { _axios } from "@/plugins/axios";
class GeneralService {
  async getPopularTramites() {
    return _axios.get("/popular-tramites").then((response: any) => {
      return response.data;
    });
  }
}

export default new GeneralService();
